import { layout, colors } from 'src/components/base';
import styled from 'styled-components';
import { Badge } from '@prisjakt/ui/badge';
import { CaptionText } from '@prisjakt/ui/text/variants';

export const ShippingOptionList = styled.div``;

export const ShippingOptionItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${layout.measurements.spacing050};
  padding: ${layout.measurements.spacing050} 0;

  > img {
    margin-right: ${layout.measurements.spacing050};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${colors.borderLightGray};
  }
`;

export const ItemTitle = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;

export const StyledBadge = styled(Badge)`
  align-self: baseline;
`;

const SUSTAINABLE_DESCRIPTION_MAX_WIDTH = '480px';

export const StyledSustainableDescription = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${layout.measurements.spacing025};
  max-width: ${SUSTAINABLE_DESCRIPTION_MAX_WIDTH};
`;

export const StyledCaptionText = styled(CaptionText)`
  line-height: 1.2;
`;
